import type { JSX, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CardV2 as Card, ProgressBar, Text } from '@feathr/components';

import type { IABTestTimelineProgress } from './ABTestReport.types';

import * as styles from './ABTestTimeline.css';

interface IProps {
  /** Trailing actions, such as ending the test early. */
  actions?: ReactNode;
  progress: IABTestTimelineProgress;
}

function ABTestTimeline({ actions, progress }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const { hoursRemaining, percentComplete } = progress;

  return (
    <Card width={'full'}>
      <Card.Content contentClassName={styles.content}>
        <div className={styles.header}>
          <Text.DefaultMedium>{t('Test timeline')}</Text.DefaultMedium>
          <div className={styles.status}>
            <Text.DefaultRegular>
              <strong>{t('{{percent}}% complete', { percent: percentComplete })}</strong>{' '}
              {t('({{count}} hours remaining)', { count: hoursRemaining })}
            </Text.DefaultRegular>
            {actions}
          </div>
        </div>
        <ProgressBar aria-label={t('Test progress')} value={percentComplete} />
      </Card.Content>
    </Card>
  );
}

export default ABTestTimeline;
